import { render } from "./AlipayDemoView.vue?vue&type=template&id=27eb2151&scoped=true"
import script from "./AlipayDemoView.vue?vue&type=script&lang=js"
export * from "./AlipayDemoView.vue?vue&type=script&lang=js"

import "./AlipayDemoView.vue?vue&type=style&index=0&id=27eb2151&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eb2151"]])

export default __exports__